import * as SkillDefaults from '@revelio/data-access/skill-defaults';

import type { TreeFilter } from '../types/filters';

// Only the GENERATED_DEFAULT_CUSTOM_SKILL_* arrays are selectable defaults;
// exclude the GENERATED_SKILL_DEFAULTS_VERSION string stamp.
type SkillDefaultsKeys = Exclude<
  keyof typeof SkillDefaults,
  'GENERATED_SKILL_DEFAULTS_VERSION'
>;

/**
 * Resolve the generated default CUSTOM_SKILL selections for a skill taxonomy
 * id (0 = the default taxonomy, higher ids = custom taxonomies — the same
 * numeric id the SKILL_TAXONOMY filter carries). Falls back to the default
 * taxonomy's list for an unrecognised id, and to `[]` when even that is absent
 * (the generator was run against an environment without `default_ids`).
 *
 * Keep the key format in sync with the generator's `formatTaxonomyName()`:
 * DEFAULT for 0, CUSTOM_<id> otherwise.
 */
export function getSkillDefaultSelectionsForTaxonomy(
  taxonomyId: number | undefined
): TreeFilter['selections'] {
  const idNum = Number(taxonomyId ?? 0);
  const nameSegment =
    Number.isNaN(idNum) || idNum === 0 ? 'DEFAULT' : `CUSTOM_${idNum}`;
  const key =
    `GENERATED_DEFAULT_CUSTOM_SKILL_${nameSegment}` as SkillDefaultsKeys;

  // biome-ignore lint/performance/noDynamicNamespaceImportAccess: keyed lookup over the generated module
  const forTaxonomy = SkillDefaults[key];
  if (forTaxonomy) return forTaxonomy;

  // biome-ignore lint/performance/noDynamicNamespaceImportAccess: see above
  return SkillDefaults['GENERATED_DEFAULT_CUSTOM_SKILL_DEFAULT'] ?? [];
}
